import React, { useState } from "react";
// Remove the unused useNavigate import
// import { useNavigate } from "react-router-dom";
import "../styles/Gallery.css";

const Gallery = () => {
  const images = [
    { id: 1, src: "/images/RixxyMC animated.gif", alt: "RixxyMC Animated Logo" },
    { id: 2, src: "/images/rixxymc-banner5.gif", alt: "RixxyMC Banner" },
    { id: 3, src: "/images/rixxymc-banner4.gif", alt: "RixxyMC Banner" },
    { id: 4, src: "/images/rixxymc-banner3.gif", alt: "RixxyMC Banner" },
    { id: 5, src: "/images/rixxymc.gif", alt: "RixxyMC Banner" },
    // Add more images here
  ];

  // Remove this line since navigate is not used:
  // const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);

  const openModal = (index) => {
    setModalImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDownload = (src) => {
    const link = document.createElement("a");
    link.href = src;
    link.download = src.split("/").pop();
    link.click();
  };

  const handleShare = (src) => {
    if (navigator.share) {
      navigator.share({
        title: "RixxyMC Gallery",
        url: window.location.href,
      });
    } else {
      alert("Sharing is not supported in your browser.");
    }
  };

  const goToNextImage = () => {
    setModalImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPreviousImage = () => {
    setModalImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const handleSwipe = (event) => {
    if (event.touches.length === 1) {
      const touchStart = event.touches[0].clientX;

      const handleTouchMove = (moveEvent) => {
        const touchMove = moveEvent.touches[0].clientX;

        if (touchStart - touchMove > 50) {
          goToNextImage();
          window.removeEventListener("touchmove", handleTouchMove);
        } else if (touchMove - touchStart > 50) {
          goToPreviousImage();
          window.removeEventListener("touchmove", handleTouchMove);
        }
      };

      window.addEventListener("touchmove", handleTouchMove);
    }
  };

  return (
    <div className="gallery-page">
      <h1>Server Gallery</h1>
      <p>Explore stunning Minecraft builds from our server!</p>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={image.id} className="gallery-item">
            <img
              src={image.src}
              alt={image.alt}
              className="gallery-image"
              onClick={() => openModal(index)}
            />
          </div>
        ))}
      </div>

      {/* Modal for viewing images */}
      {isModalOpen && (
        <div className="modal" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleSwipe}
          >
            <button className="close-button" onClick={closeModal}>
              ✖
            </button>

            <div className="image-container">
              <button
                className="arrow-button left"
                onClick={goToPreviousImage}
              >
                ←
              </button>
              <img
                src={images[modalImageIndex].src}
                alt="Large view"
                className="modal-image"
              />
              <button
                className="arrow-button right"
                onClick={goToNextImage}
              >
                →
              </button>
            </div>

            <div className="modal-actions">
              <button onClick={() => handleDownload(images[modalImageIndex].src)}>
                Download
              </button>
              <button onClick={() => handleShare(images[modalImageIndex].src)}>
                Share
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
